import React, { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { updateQuiz } from '../../features/quiz/quizSlice'

/**
 * YESORNO COMPONENT
 * @param {{ questionNumber: number, answer: 'Oui' | 'Non' | '', setAnswer: () => void }} props 
 * @returns {JSX.Element}
 */
function YesOrNo({ questionNumber }) {
  const dispatch = useDispatch()
  const toggleAnswer = useCallback((e) => {
    const asr = e.target.id.split('-')[1]
    dispatch(updateQuiz({ [`${questionNumber}`]: asr }))
  }, [questionNumber])

  return (
    <span className="flex item-center space-x-2">
      {/* <button onClick={toggleAnswer} type='button' name='Oui' className={`${padding} btn ${answer === 'Oui' ? 'bg-general-blue ' : ''}`}>
        Oui
      </button>
      <button onClick={toggleAnswer} type='button' name='Non' className={`${padding} btn ${answer === 'Non' ? 'text-white bg-general-teal' : 'bg-gray-200 text-general-blue/90 hover:text-white hover:bg-general-blue/90'}`}>
        Non
      </button> */}
      <label htmlFor={questionNumber + '-Oui'} onClick={toggleAnswer} className="flex space-x-2 items-center text-gray-700 font-light mt-4 pl-4 cursor-pointer hover:text-stone-900">
        <input type='radio' name={questionNumber} id={questionNumber + '-Oui'} className="radio radio-accent shadow-general-teal peer" focus='false' />
        <span className="peer-checked:text-general-teal">Oui</span>
      </label>
      <label htmlFor={questionNumber + '-Non'} onClick={toggleAnswer} className="flex space-x-2 items-center text-gray-700 font-light mt-4 pl-4 cursor-pointer hover:text-stone-900">
        <input type='radio' name={questionNumber} id={questionNumber + '-Non'} className="radio radio-accent shadow-general-teal peer" focus='false' />
        <span className='peer-checked:text-general-teal'>Non</span>
      </label>
    </span>
  )
}

export default memo(YesOrNo)